import { render, staticRenderFns } from "./successCase.vue?vue&type=template&id=5d4d70df&scoped=true"
import script from "./successCase.vue?vue&type=script&lang=js"
export * from "./successCase.vue?vue&type=script&lang=js"
import style0 from "./successCase.vue?vue&type=style&index=0&id=5d4d70df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d70df",
  null
  
)

export default component.exports